<script>
import request from '@utils/request'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    resource: {
      type: String,
      required: true,
      validator: function (value) {
        return ['staff', 'merchant', 'product', 'prepaid', 'pet', 'deposit', 'memberLevel'].includes(value)
      },
    },
    circle: {
      type: Boolean,
      default: false,
    },
    onlyUpLoad: {
      type: Boolean,
      default: false,
    },
    suggestSize: {
      type: String,
      default: '',
    },
    imageSize: {
      type: String,
      default: '',
    },
    dir: {
      type: String,
      default: '',
    },
    noRemove: {
      type: Boolean,
      default: false
    },
    isDeposit: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default',
    },
    isBetween: {
      type: Boolean,
      default: false
    },
    moreWidth: {
      type: Boolean,
      default: false
    },
    imgCircle: {
      type: Boolean,
      default: false
    },
    // 是否立刻刪除
    immediateDelete: {
      type: Boolean,
      default: true
    },
    // 是否為column顯示
    displayColumn: {
      type: Boolean,
      default: false
    },
    // 是否為100%寬度
    widthFull: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      tryingToUpload: false,
    }
  },
  mounted() {
  },
  computed: {
    urlWithTimestamp() {
      const timestamp = Date.now()
      return `${this.value}?${timestamp}`
    }
  },
  methods: {
    emitInput(value = '') {
      this.$emit('input', value)
    },
    beforeImageUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml' || file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 <= 10

      if (!isJPGOrPNG) {
        this.$message.error('上傳的頭像圖片只能是 JPG 或 PNG 或 GIF 格式')
      }
      if (!isLt2M) {
        this.$message.error('上傳的頭像圖片大小不能超過 10 MB')
      }
      return isJPGOrPNG && isLt2M
    },
    async handleUpload(params) {
      const formData = new FormData()
      formData.append('files[]', params.file)
      if (this.dir) {
        formData.append('dir', this.dir)
      }
      this.tryingToUpload = true
      let uploadedValue = ''
      const url = this.isDeposit ? '/admin/deposit/media/upload' : '/admin/merchant/media/upload'
      const response = await request.post(
        url,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      uploadedValue = this.isDeposit ? response.items[0] : response
      this.emitInput(uploadedValue)
      this.tryingToUpload = false
    },
    async handleRemove(path) {
      const isExternal = /^(https?:)/.test(path)
      if (!isExternal) {
        if (this.type === 'custom') {

        } else {
          const formData = new FormData()
          formData.append('paths[]', path)
          formData.append('resource', this.resource)
          if (this.immediateDelete) {
            await request.post('/admin/merchant/media/delete', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
          }

        }

      }

      this.emitInput()
    },
    handlePreview(file) {
      this.dialogImageUrl = file
      this.dialogVisible = true
    },
    sendSuccess() {
      this.$emit('sendSuccess', true)
    }
  },
}
</script>

<template>
  <div>
    <div :class="{
      [$style.containerBox]: isBetween,
      [$style.moreWidth]: moreWidth,
      [$style.displayColumn]: displayColumn,
    }">
      <div :class="[$style.container, { [$style['uploader--circle']]: circle, [$style.widthFull]: widthFull }]">
        <el-upload v-loading="tryingToUpload" action="string" :on-success="sendSuccess" :http-request="handleUpload"
          :before-upload="beforeImageUpload" :show-file-list="false"
          :class="[$style.uploader, { [$style['is-emtpy']]: !value && resource !== 'pet', [$style['uploader--circle']]: circle }]">
          <el-image v-if="value" :src="value" fit="cover">
            <div slot="placeholder">
              載入中
              <span class="dot">...</span>
            </div>
          </el-image>
          <div v-else>
            <template v-if="resource === 'pet'">
              <div v-if="$appType() === 'ipetbooking'"
                :style="{ backgroundImage: `url('${require('@assets/images/pet-avatar-default@2x.png')}')` }"
                class="el-upload__img"></div>
              <div v-if="$appType() === 'dingbeauty'"
                :style="{ backgroundImage: `url('${require('@assets/images/person_background.svg')}')` }"
                class="el-upload__img"></div>
              <div class="el-upload__more">
                <el-button type="primary" class="is-circle">
                  <i class="fal fa-plus"></i>
                </el-button>
              </div>
            </template>
            <template v-else-if="resource === 'staff'">
              <div :style="{ backgroundImage: `url('${require('@assets/images/person_background.svg')}')` }"
                class="el-upload__img"></div>
              <div class="el-upload__more">
                <el-button type="primary" class="is-circle">
                  <i class="fal fa-plus"></i>
                </el-button>
              </div>
            </template>
            <template v-else>
              <div class="uploader_iconBox">
                <BaseIcon name="image" :class="$style['uploader__icon']" />
              </div>
              <div>{{ $root.isTouchDevice ? '觸碰上傳圖片' : '點擊上傳圖片' }}</div>
            </template>
          </div>
        </el-upload>
        <span v-if="value"
          :class="[$style.actions, imgCircle || circle ? $style['actions--circle'] : $style['actions--rect']]">
          <el-tooltip effect="dark" content="預覽圖片" placement="top">
            <span @click="handlePreview(value)">
              <BaseIcon name="eye" />
            </span>
          </el-tooltip>
          <el-tooltip v-if="!noRemove" effect="dark" content="刪除圖片" placement="top">
            <span @click="handleRemove(value)">
              <BaseIcon name="trash-alt" />
            </span>
          </el-tooltip>
        </span>
      </div>
      <div v-if="!onlyUpLoad"
        :class="[$style.uploader__limit, { 'text-center': resource === 'pet', [$style.widthFull]: widthFull }]">
        圖檔最大 10 MB，檔案格式限 JPG 、 PNG 、 SVG 、 GIF
        <template v-if="suggestSize">
          <br />
          <span v-if="imageSize">圖片比例：{{ imageSize }}，</span>建議尺寸：{{ suggestSize.replace('/', '*') }}px
        </template>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="1135px" top="0" append-to-body>
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.containerBox {
  display: flex;

  @include max-md {
    display: block;
  }

  .container {
    width: 40%;
    margin-right: 1.5rem;

    @include max-lg {
      width: 40%;
    }

    @include max-md {
      width: 100%;
      margin-right: 0;
    }
  }

  .uploader__limit {
    align-self: end;
    text-align: left;

    // padding-bottom: 2rem ;
    @include max-md {
      padding-bottom: 0;
    }
  }
}

.moreWidth {
  width: 500px;
  text-align: center;

  @include max-md {
    width: 100%;
  }
}

.container {
  position: relative;
  margin-top: 10px;
}

.uploader {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 216px;
  margin: auto;
  overflow: hidden;
  border-radius: $border-radius;

  :global {

    .el-upload,
    .el-image {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: #404040;

      svg {
        color: $color-primary-light;
      }
    }

    .el-upload {
      &__img {
        width: 140px;
        height: 140px;
        background-color: #eee;
        background-position: center;
        background-size: cover;
        border-radius: 100%;
        opacity: 1;
        transition: opacity 0.3s;
        position: relative;

        &:hover {
          opacity: 0.85;
        }
      }

      &__more {
        position: absolute;
        right: 10px;
        bottom: 10px;
        border: 3px solid #FFF;
        border-radius: 100%;
        letter-spacing: 0;
        width: 40px;
        height: 40px;

        button {
          padding: 0;
          width: 34px;
          height: 34px;
        }

        i {
          font-size: 1.7rem;
        }
      }
    }

    .uploader {
      &_iconBox {
        width: 60px;
        height: 60px;
        background: $color-input-bg;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 11px;
        margin: 0 auto;
      }
    }
  }

  &__iconBg {
    margin: 0 auto;
    width: 60px;
    height: 60px;
    border-radius: 60px;
    background-color: #f2f2f2;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
  }

  &__icon {
    font-size: ms(6);
    color: $color-primary;
  }

  &__limit {
    margin-top: 10px;
    line-height: 1.5;
    color: $color-text-light;
  }

  &--circle {
    width: 160px;
    height: 160px;
    margin: auto;
    border-radius: 50% !important;

    .actions {
      border-radius: 50%;
    }
  }

  &.is-emtpy {
    border: 2px dashed #E5E7EB;
    border-radius: 15px;

    &:hover :global {

      .el-upload,
      .el-image {
        color: lighten(#404040, 20);
      }
    }
  }
}

.actions {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 10px;
  width: 100%;
  height: 100%;
  font-size: ms(3);
  color: black;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: $fade-transition;
  border-radius: 8px;

  &--rect {
    justify-content: flex-end;
  }

  &--circle {
    justify-content: center;
    align-items: center;
  }

  span {
    background-color: white;
    border-radius: 8px;
    height: 44px;
    width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    cursor: pointer;

    +span {
      margin-left: 15px;

      @include max-md {
        margin-left: 6px;
      }
    }
  }

  &:hover {
    opacity: 1;
  }
}

.displayColumn {
  flex-direction: column;
  flex-direction: flex-start;
}

.widthFull {
  width: 100% !important;
}</style>
